import { useEffect } from "react";
import { useRag } from "../RagContext";
import DocumentUpload from "./DocumentUpload";
import DocumentList from "./DocumentList";
import "./DocumentsSection.css";

export default function DocumentsSection() {
    const { currentBandoId, documents, loadDocuments } = useRag();

    // Carica documenti quando cambia il bando
    useEffect(() => {
        if (currentBandoId) {
            loadDocuments(currentBandoId);
        }
    }, [currentBandoId, loadDocuments]);

    // Polling: re-fetch ogni 3s finche' c'e' almeno un doc in 'processing'.
    // Auto-stop quando tutti i doc sono ready/failed.
    useEffect(() => {
        if (!currentBandoId) return;
        if (!documents.some((d) => d.status === "processing")) return;
        const interval = setInterval(() => {
            loadDocuments(currentBandoId);
        }, 3000);
        return () => clearInterval(interval);
    }, [documents, currentBandoId, loadDocuments]);

    if (!currentBandoId) {
        return (
            <div className="rag-docs-section__empty">
                <p>Seleziona un bando per gestire i documenti.</p>
            </div>
        );
    }

    return (
        <div className="rag-docs-section">
            <DocumentUpload />
            <DocumentList />
        </div>
    );
}
